<template>
  <div>
    <AddTruckModal :companyId="companyId" />
    <UpdateTruckModal :truck="truck" :companyId="companyId" />
    <AssignTruckModal :truckId="truckId" :companyId="companyId" />
    <AddCompanyDriver :companyId="companyId" />
    <UpdateDriverModal :driverInfo="driverInfo" :companyId="companyId" />
    <AssignDriverModal :driverId="driverId" :companyId="companyId" />
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/Group 440.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h4 class="primary-color font-600">
                  {{ $t("text.cTrucks.title") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.cTrucks.desc") }}
                </p>
              </div>
              <div class="col-md-5 text_right" v-if="tabName === 'trucks'">
                <button
                  class="add__new__retainership_btn"
                  style="border-radius: 6px; background-color: #370f70"
                  @click="addTruck"
                >
                  {{ $t("text.cTrucks.addTruck") }}
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    height="35px"
                    class="ml-3 loader"
                  />
                </button>
              </div>
              <div class="col-md-5 text_right" v-if="tabName === 'drivers'">
                <button
                  class="add__new__retainership_btn"
                  style="border-radius: 6px; background-color: #370f70"
                  @click="addDriver"
                >
                  {{ $t("text.cTrucks.addDriver") }}
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    height="35px"
                    class="ml-3 loader"
                  />
                </button>
              </div>
              <div class="col-md-5 flexify"></div>
            </div>
          </div>
          <div class="col-md-4" v-if="tabName === 'trucks'">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.cTrucks.totalTruck") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/Group 440.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ truckNo }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4" v-if="tabName === 'drivers'">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.cTrucks.totalDriver") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/Group 440.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ driverNo }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4" v-if="tabName === 'assignedTrucks'">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.cTrucks.totalAssigned") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/Group 440.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ assignedNo }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-banner mt-3">
          <div class="sub-nav">
            <ul class="d-flex">
              <li
                @click="() => (tabName = 'trucks')"
                @change="getTrucks"
                :class="tabName === 'trucks' ? 'active-nav' : null"
                class="mr-5 pb-3 px-1"
              >
                {{ $t("text.cTrucks.allTruck") }}
              </li>
              <li
                @click="() => (tabName = 'drivers')"
                @change="getDrivers"
                :class="tabName === 'drivers' ? 'active-nav' : null"
                class="mr-5 pb-3 px-1"
              >
                {{ $t("text.cTrucks.allDrivers") }}
              </li>
              <li
                @click="() => (tabName = 'assignedTrucks')"
                @change="getDriversWithTruck"
                :class="tabName === 'assignedTrucks' ? 'active-nav' : null"
              >
                {{ $t("text.cTrucks.assignedTrucks") }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <TrucksTab :companyId="companyId" v-if="tabName === 'trucks'" />
      <DriversTab :companyId="companyId" v-if="tabName === 'drivers'" />
      <AssignedTrucksTab
        :companyId="companyId"
        v-if="tabName === 'assignedTrucks'"
      />
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import TrucksTab from "./Trucks/trucks.vue";
import DriversTab from "./Drivers/drivers.vue";
import AssignedTrucksTab from "./AssignedTrucks/assignedTrucks.vue";
import configObject from "@/config";
import AddTruckModal from "@/components/modals/Trucks/addTruck.vue";
import UpdateTruckModal from "@/components/modals/Trucks/editTruck.vue";
import AssignTruckModal from "@/components/modals/Trucks/assignTruck.vue";
import AddCompanyDriver from "@/components/modals/Drivers/addDriver.vue";
import UpdateDriverModal from "@/components/modals/Drivers/editDriver.vue";
import AssignDriverModal from "@/components/modals/Drivers/assignDriver.vue";

export default {
  title: "Truck/Driver List :: Epump Portal",
  name: "TrucksAndDrivers",
  components: {
    MasterLayout,
    AddTruckModal,
    UpdateTruckModal,
    AssignTruckModal,
    TrucksTab,
    DriversTab,
    AssignedTrucksTab,
    AddCompanyDriver,
    UpdateDriverModal,
    AssignDriverModal,
  },

  data() {
    return {
      company: null,
      backgroundUrl,
      cardBackgroundUrl,
      companyId: null,
      showLoader: true,
      tabName: "trucks",
      truckNo: "",
      driverNo: "",
      assignedNo: "",
      truck: [],
      truckId: "",
      driverId: "",
      driverInfo: [],
    };
  },

  watch: {
    company(company) {
      if (company !== null) {
        this.getTrucks();
        this.getDrivers();
        this.getDriversWithTruck();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyId = this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company.id;
      if (this.company !== null) {
        this.getTrucks();
        this.getDrivers();
        this.getDriversWithTruck();
      }
    });
    if (this.$route.query.companyId) {
      this.getTrucks();
      this.getDrivers();
      this.getDriversWithTruck();
    }
    this.$eventHub.$on("_assignTruck", (id) => {
      this.assignTruck(id);
    });
    this.$eventHub.$on("_updateTruck", (data) => {
      this.updateTruck(data);
    });
    this.$eventHub.$on("_assignDriver", (id) => {
      this.assignDriver(id);
    });
    this.$eventHub.$on("_updateDriver", (data) => {
      this.updateDriver(data);
    });
    this.$eventHub.$on("getTrucks", () => {
      this.getTrucks();
    });
    this.$eventHub.$on("getDriversWithTruck", () => {
      this.getDriversWithTruck();
    });
    this.$eventHub.$on("getDrivers", () => {
      this.getDrivers();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("_assignTruck");
    this.$eventHub.$off("_updateTruck");
    this.$eventHub.$off("getTrucks");
    this.$eventHub.$off("_assignDriver");
    this.$eventHub.$off("_updateDriver");
    this.$eventHub.$off("getDrivers");
    this.$eventHub.$off("getDrivers");
    this.$eventHub.$off("getDriversWithTruck");
  },
  methods: {
    addTruck() {
      this.$modal.show("addTruck");
    },
    addDriver() {
      this.$modal.show("addDriver");
    },
    assignTruck(id) {
      this.truckId = id;
      this.$modal.show("assignTruckModal");
    },
    updateTruck(data) {
      this.truck = data;
      this.$modal.show("editTruck");
    },
    assignDriver(id) {
      this.driverId = id;
      this.$modal.show("assignDriverModal");
    },
    updateDriver(data) {
      this.driverInfo = data;
      this.$modal.show("editDriver");
    },
    getTrucks() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyTrucks/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.$eventHub.$emit("getTruckzz");
          this.truckNo = response.data.length;
        })
        .catch((error) => {});
    },
    getDrivers() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyDrivers/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.driverNo = response.data.length;
        })
        .catch((error) => {});
    },
    getDriversWithTruck() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyDriversWithTruck/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.assignedNo = response.data.length;
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
  .overhead {
    flex-flow: column wrap !important;
  }
}
.wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.sub-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav li {
  color: #2b2b2b;
  font-size: 16px;
  cursor: pointer;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}
</style>
